import {createStrokeSVG} from './TEMPLATE'

// lucide: newspaper
export const Newspaper_Stroke2_Corner2_Rounded = createStrokeSVG({
  paths: [
    'M15 18h-5',
    'M18 14h-8',
    'M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2',
    'M11 6h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
